import { render } from "./DoubleAuthenticationStatus.vue?vue&type=template&id=5185bd36&scoped=true"
import script from "./DoubleAuthenticationStatus.vue?vue&type=script&lang=js"
export * from "./DoubleAuthenticationStatus.vue?vue&type=script&lang=js"

import "./DoubleAuthenticationStatus.vue?vue&type=style&index=0&id=5185bd36&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5185bd36"]])

export default __exports__